//@flow

import React from 'react';
import PropTypes from 'prop-types';
import SingleCode from './single';
import './style.css';

type Props = {
    Content: Object
};
function SampleCode(props: Props) {
    const { Content } = props;

    return (
        <>
            {Content.SampleCodes != null ? (
                Content.SampleCodes.length >= 2 ? (
                    Content.SampleCodes.map((SampleCode, index) => (
                        <SingleCode Content={SampleCode} key={index} />
                    ))
                ) : (
                    <SingleCode Content={Content.SampleCodes} />
                )
            ) : (
                ''
            )}
        </>
    );
}
SampleCode.propTypes = {
    Content: PropTypes.object
};
export default SampleCode;
